



























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ProjectAsCustomerEditModel, ProjectEditModel } from "@/services/api/nswag/stapiclient_generated";
import StDatePicker from "@/components/basic/StDatePicker.vue";
import ProjectChangeFixedPriceWarning from "@/views/Projects/ProjectChangeFixedPriceWarning.vue";
import StCurrencyInput from "@/components/basic/StCurrencyInput.vue";
import StPercentInput from "@/components/basic/StPercentInput.vue";
import { UserStore } from "@/store/user-module";

@Component({
  components: {
    StPercentInput, StCurrencyInput, ProjectChangeFixedPriceWarning, StDatePicker
  },
})
export default class EditCustomerProject extends Vue {
  @Prop() value: ProjectEditModel | ProjectAsCustomerEditModel;
  @Prop() isReadonly: boolean;

  get project(){
    return this.value;
  }

  set project(data: ProjectEditModel | ProjectAsCustomerEditModel){
    this.$emit('input', data);
  }

  get useFixedPriceProjects(){
    return UserStore.userSettings.useFixedPriceProjects;
  }

  get budgetUnitOptions() {
    return [
      { id: "Currency", description: UserStore.userSettings.currency, disabled: UserStore.userSettings.noRates },
      { id: "Hours", description: "h (alle)" },
      { id: "HoursBillable", description: "h (verrechenbar)" }
    ];
  }

  setThresholdIfZero() {
    if (this.project.notifyOnBudgetOverrun && this.project.budgetOverrunThresholdPercent == 0) {
      this.project.budgetOverrunThresholdPercent = 100;
    }
  }
}
